import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Button from './Button'

import styles from './ConfirmNotification.module.scss'

const ConfirmNotification = ({ message, label, onConfirm, onCancel, buttonOneText, buttonTwoText, className }) => { 
  const classNames = cn(styles.confirmNotification, className)

  return (
    <div className={classNames}>
      <div className={styles.bodyContainer}>
        <div><span className={styles.label}>{label}: </span>{message}</div>
        <div className={styles.buttons}>
          <Button className={styles.cancel} onClick={onCancel}>{buttonOneText}</Button>
          <Button className={styles.confirm} onClick={() => { 
            onConfirm() 
            onCancel()
           }}>
            {buttonTwoText}
          </Button>
        </div>
      </div>
    </div>
  )
}

ConfirmNotification.defaultProps = {
  message: 'Please Confirm if you would like to continue',
  label: 'Warning',
  onConfirm: () => {},
  onCancel: () => {},
  buttonOneText: 'Cancel',
  buttonTwoText: 'Confirm',
}
  
ConfirmNotification.defaultProps = {
  message: PropTypes.string,
  label: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  buttonOneText: PropTypes.string,
  buttonTwoText: PropTypes.string,
}
  
  export default ConfirmNotification
